module.exports = __webpack_public_path__ + "static/media/residual-value-chart-blurred.17bb3077.png";